import React from "react";
import Form from "@/components/common/form/form";
import { authServices } from "services/auth.services";
import Model from "@/components/common/model.component";
import PivotForm from "./pivotForm";
import { useTranslation } from "react-i18next";
import _objI from "@/utils/_objI";
import { PivotService } from "services/assets-pivot.service";
import PageTitle from "components/common/page-title.component";

const EditWaterSource = ({
  type,
  showModal,
  setShowModal,
  rowData,
  setRowData,
  setRefresh,
}) => {
  const { t } = useTranslation();

  const onSubmit = async (data) => {
    data.entity_type_id = 12;
    data.org_id = authServices.userValue.org_id;
    data.farm_id = Number(data.farm_id);
    data.field_id = Number(data.field_id);
    data.supplier_id = Number(data.supplier_id) || null;
    data.number_of_towers = data.towers_details.length;
    data.last_tower_speed = Number(data.last_tower_speed);
    data.end_gun_exist = data.end_gun_exist === "true" ? true : false;
    data.towers_details = data.towers_details.filter(
      (item) => (
        (item.tower_length = Number(item.tower_length)),
        (item.sprinkles = Number(item.sprinkles)),
        (item.sprinkle_water_flow = Number(item.sprinkle_water_flow))
      )
    );

    let res = await PivotService.editPivot(data, rowData.id);
    if (res) {
      setShowModal(!showModal);
      setRefresh(1);
      setRowData({});
    }
  };

  return (
    _objI(rowData) && (
      <>
        <Model
          width="w-130"
          show={showModal}
          onClose={(e) => {
            setShowModal(false);
          }}
        >
          <PageTitle title={t("EditPivot")} titletextSize="text-xl" />

          <Form
            onSubmit={onSubmit}
            defaultValues={_objI(rowData) ? { ...rowData } : { ...rowData }}
          >
            <PivotForm type={type} RowData={rowData} passProps icon={""} />
          </Form>
        </Model>
      </>
    )
  );
};
export default EditWaterSource;
